import { createStyles, makeStyles } from "@material-ui/core";
export default makeStyles(function (theme) {
    return createStyles({
        listItem: {
            display: "flex",
            flex: "1 1 100%",
            justifyContent: "center",
            alignItems: "center",
            color: theme.palette.common.white,
            cursor: "pointer",
            paddingLeft: "0 !important",
            paddingRight: 0,
            height: 32,
            width: 158,
            borderRadius: "4px !important",
            "&:hover": {
                background: "rgba(255, 255, 255, .10) ",
            },
        },
        activeUrl: {
            background: "".concat(theme.palette.background.paper, " "),
            "& path": {
                fill: theme.palette.primary.dark,
                color: theme.palette.primary.dark,
            },
            "&:hover": {
                background: "".concat(theme.palette.background.paper, " "),
                fill: theme.palette.primary.dark,
                color: theme.palette.primary.dark,
            },
            fill: theme.palette.primary.dark,
            color: theme.palette.primary.dark,
        },
        unActiveUrl: {
            background: "transparent",
        },
        icon: {
            width: 44,
            minWidth: 44,
            maxWidth: 44,
            height: 44,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fill: theme.palette.common.white,
            color: theme.palette.common.white,
        },
        arrowIcon: {
            width: 44,
            minWidth: 44,
            maxWidth: 44,
            height: 44,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        menuClose: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: 24,
            height: 24,
            borderRadius: "4px",
            padding: theme.spacing(0.2, 0.3),
            "&:hover": {
                background: "rgba(255, 255, 255, .10) ",
            },
        },
        menuCloseActive: {
            background: "".concat(theme.palette.background.paper, " !important"),
            "& path": {
                fill: theme.palette.primary.dark,
                color: theme.palette.primary.dark,
            },
        },
        menuCloseActiveunActiveUrl: {
            background: "transparent",
            "&:hover": {
                background: "rgba(255, 255, 255, .10)",
                fill: theme.palette.primary.dark,
                color: theme.palette.primary.dark,
            },
            "& path": {
                fill: theme.palette.common.white,
                color: theme.palette.common.white,
            },
        },
        text: {
            flex: "1 0 auto",
        },
        root: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: "1 1 100%",
            color: theme.palette.common.white,
            cursor: "pointer",
            padding: "0px 4px",
            height: 35,
            overflow: "hidden",
            margin: "5px 0px",
        },
        collapsableIconArrow: {
            color: "#fff",
        },
        collapsedIconArrow: {
            transform: "rotate(45deg)",
        },
    });
});
